var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"g-tit01"},[_c('i',{staticClass:"left",style:({marginRight: _vm.offset + 'px'})}),_vm._v(" "),_c('span',{ref:"title",staticClass:"tit01"},[_vm._v(_vm._s(_vm.title))]),_vm._v(" "),_c('i',{staticClass:"right",style:({marginLeft: _vm.offset + 'px'})})])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-34f23efa","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/views/components/gTit01.vue
// module id = null
// module chunks = 